import * as React from "react";
import { observer } from "mobx-react";
import { Action, Icon, IconItem, IconName, IconSize, ItemGroup, Menu, Trigger, UnstyledButton } from "@root/shared";
import { withTranslation, WithTranslation } from "react-i18next";
import { logger } from "@root/lib/telemetry";
import { SupportUIStoreContext } from "../support-ui-store";
import { checkBothFeatureStores } from "@root/stores/utils/check-both-features";
import { OptimizelyFeatureNames } from "@lib/common-interfaces";

const styles = require("./support-menu.scss");

export const SupportMenu = withTranslation("common")(
  observer(
    class SupportMenu extends React.Component<WithTranslation, {}> {
      public render() {
        const { t } = this.props;
        const supportMenuListStyles = styles.supportMenuList;
        const supportMenuStyles = styles.supportMenu;
        return (
          <Menu listClassName={supportMenuListStyles} backdrop backdropClassName={styles.lightBackdrop} data-test-id="support-menu">
            <Trigger activeClassName={styles.active} data-test-id="support-menu-trigger">
              <UnstyledButton
                className={supportMenuStyles}
                aria-label={t("common:navigation.supportMenu.label")}
                onClick={this.openSupportMenu}
              >
                <Icon icon={IconName.QuestionMark} size={IconSize.XSmall} />
              </UnstyledButton>
            </Trigger>

            <ItemGroup>
              <Action
                text={t("common:navigation.supportMenu.systemStatus")}
                onClick={this.systemStatus}
                target="_blank"
                href="https://status.appcenter.ms/"
              >
                <IconItem icon={IconName.Satellite} title={t("common:navigation.supportMenu.systemStatus")} />
              </Action>
            </ItemGroup>
            <ItemGroup>
              <Action
                text={t("common:navigation.supportMenu.docs")}
                onClick={this.openDocs}
                target="_blank"
                href="https://aka.ms/appcenterdocs"
              >
                <IconItem icon={IconName.Docs} title={t("common:navigation.supportMenu.docs")} />
              </Action>
              <Action
                text={t("common:navigation.supportMenu.roadmap")}
                onClick={this.roadmap}
                target="_blank"
                href="https://github.com/Microsoft/appcenter/wiki/Roadmap"
              >
                <IconItem icon={IconName.SignalFlag} title={t("common:navigation.supportMenu.roadmap")} />
              </Action>
              <Action
                text={t("common:navigation.supportMenu.topRequests")}
                onClick={this.openTopRequests}
                href="https://github.com/Microsoft/appcenter/issues?utf8=%E2%9C%93&q=is%3Aissue+is%3Aopen+sort%3Areactions-%2B1-desc+label%3A%22feature+request%22+"
                target="_blank"
              >
                <IconItem icon={IconName.Star} title={t("common:navigation.supportMenu.topRequests")} />
              </Action>
              <Action
                text={t("common:navigation.supportMenu.submitIssue")}
                onClick={this.openSubmitIssue}
                href="https://github.com/Microsoft/appcenter/issues/new?assignees=&labels=feature+request&template=feature_request.md&title="
                target="_blank"
              >
                <IconItem icon={IconName.Send} title={t("common:navigation.supportMenu.submitIssue")} />
              </Action>
            </ItemGroup>
            {checkBothFeatureStores(OptimizelyFeatureNames.service_desk, "service_desk") ? (
              <ItemGroup>
                <SupportUIStoreContext.Consumer>
                  {({ show }) => (
                    <Action
                      text={t("common:navigation.supportMenu.contactSupport")}
                      onClick={() => this.contactSupport(show)}
                      tabIndex={0}
                    >
                      <IconItem icon={IconName.Support} title={t("common:navigation.supportMenu.contactSupport")} />
                    </Action>
                  )}
                </SupportUIStoreContext.Consumer>
              </ItemGroup>
            ) : null}
          </Menu>
        );
      }

      private systemStatus() {
        logger.info("support-menu/system-status");
      }

      private openDocs() {
        logger.info("support-menu/docs");
      }

      private roadmap() {
        logger.info("support-menu/roadmap");
      }

      private openTopRequests() {
        logger.info("public-repo/top-requests");
      }

      private openSubmitIssue() {
        logger.info("public-repo/submit-issue");
      }

      private openSupportMenu() {
        logger.info("support-menu/open-support-menu");
      }

      private contactSupport = (show: any) => {
        show();
        logger.info("support-menu/open-contact-support");
      };
    }
  )
);
